import { useMutation } from '@tanstack/react-query';
import { EmploymentStatus } from 'hooks/webapi/useClient';
import { fetchData } from '../../../utils';
import useError from '../../useError';
import useSmartlook from '../../useSmartlook';
import { Occupation } from './useClientEmploymentDetails';

function useClientEmployerMutation() {
  const { error } = useSmartlook();
  const { showError } = useError();
  return useMutation<
    {
      rejected: boolean;
    },
    unknown,
    ClientEmployerMutationOptions
  >({
    mutationFn: async (payload) => {
      try {
        const resp = await fetchData('/client/employer', {
          method: 'put',
          body: JSON.stringify(payload),
        });

        return resp;
      } catch (e) {
        error('[useClientEmployerMutation][PUT /client/employer]', e);
        showError();
        throw e;
      }
    },
  });
}

export type ClientEmployerMutationOptions = {
  name?: string;
  phone?: string;
  employmentStatus?: EmploymentStatus;
  address?: string;
  naceCodes?: Array<string>;
  employmentDetail?: Occupation['name'];
};

export default useClientEmployerMutation;
